import { LayoutSize } from '~/graphql/types';
import type { SystemSize } from '~/theme';

const layoutSizeToSystemSize = (layoutSize: LayoutSize): SystemSize | null => {
  switch (layoutSize) {
    case LayoutSize.Xxxs:
      return 'xxxs';
    case LayoutSize.Xxs:
      return 'xxs';
    case LayoutSize.Xs:
      return 'xs';
    case LayoutSize.S:
      return 's';
    case LayoutSize.Base:
      return 'base';
    case LayoutSize.M:
      return 'm';
    case LayoutSize.L:
      return 'l';
    case LayoutSize.Xl:
      return 'xl';
    case LayoutSize.Xxl:
      return 'xxl';
    case LayoutSize.Xxxl:
      return 'xxxl';
    default:
      return null;
  }
};

export default layoutSizeToSystemSize;
